module.exports = __webpack_public_path__ + "img/kvk.7374f871.svg";